import useSubCatalogueGroupedData from "hook/useSubCatalogueGroupedData";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CatalogueAccordion from "./CatalogueAccordion";
import NoDataView from "../noDataView";

export default function DrawerMenu({ isOpen, onClose }) {

  const [activeTab, setActiveTab] = useState("Category"); // State for active tab
  const { subGroupedData, loading } = useSubCatalogueGroupedData();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // cleanup (important)
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!loading && subGroupedData.length === 0) {
    return (
        <NoDataView title="কোনো পণ্য পাওয়া নেই"/>
    );
  }

  return (
    <div className="relative">
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={onClose}
        ></div>
      )}

      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-md z-50 transform transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } md:relative md:translate-x-0 md:shadow-none md:w-64`}
      >


        {/* Tabs */}
        <div className="flex border-b">
          <button
            className={`flex-1 py-3 text-xs font-medium ${activeTab === "Category" ? " border-b-2 border-backgroundColor bg-gray-200" : "text-gray-500"}`}
            onClick={() => setActiveTab("Category")}
          >
            ক্যাটাগরি
          </button>
          <button
            className={`flex-1 py-3 text-xs font-medium ${activeTab === "Menu" ? "border-b-2 border-backgroundColor  bg-gray-200" : "text-gray-500"}`}
            onClick={() => setActiveTab("Menu")}
          >
            ম্যানু
          </button>
        </div>

        {/* Tab Content */}
        <div className="overflow-y-auto h-[calc(100%-120px)]">
          {activeTab === "Category" && (
            <div className="flex flex-col">
              <CatalogueAccordion data={subGroupedData} />
            </div>
          )}

          {activeTab === "Menu" && (
            <div className="flex flex-col">
              <Link
                to="/"
                className="flex items-center space-x-3 text-gray-700 hover:text-backgroundColor  cursor-pointer border-b py-3 px-4"
              >
                <span className="text-xs">🏠</span>
                <span className="text-xs font-medium">Home</span>
              </Link>
              <Link
                to="/hotOffer"
                className="flex items-center space-x-3 text-gray-700 hover:text-backgroundColor  cursor-pointer border-b py-3 px-4"
              >
                <span className="text-xs">🔥</span>
                <span className="text-xs font-medium">Hot Offers</span>
              </Link>
              <Link
                to="/cart"
                className="flex items-center space-x-3 text-gray-700 hover:text-backgroundColor  cursor-pointer border-b py-3 px-4"
              >
                <span className="text-xs">🛒</span>
                <span className="text-xs font-medium">Cart</span>
              </Link>
              <Link
                to="/orderDetails"
                className="flex items-center space-x-3 text-gray-700 hover:text-backgroundColor  cursor-pointer border-b py-3 px-4"
              >
                <span className="text-xs">📋</span>
                <span className="text-xs font-medium">Order Details</span>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
